import { useQuery } from '@tanstack/react-query';
import { DepartmentSchema, type Department } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useDepartment(id: string) {
  const client = useApiClient();
  return useQuery<Department>({
    queryKey: ['department', id],
    queryFn: ({ signal }) =>
      client.get<Department>(`/departments/${id}`, { signal }, DepartmentSchema),
  });
}
